import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'dialogtitle',
  templateUrl: './dialog-title.component.html'
})
export class DialogTitleComponent {

  @Input() title: string;
  @Input() titleTheme: string = 'default';
  @Output() close = new EventEmitter<any>();

  onClose() {
    this.close.emit();
  }

}